import axios from './request'
import config from '@/config'

const { baseURL } = config;

const getHeaders = () => {
  const userId = localStorage.getItem('userId') ? +localStorage.getItem('userId') : '';
  const userToken = localStorage.getItem('userToken');
  return {
    userId,
    userToken,
  }
}

// 用户进入页面上报接口
export const enterReport = () => {
  let url = baseURL + 'h5/tokyoOlympic/enterReport';
  const headers = getHeaders();
  return axios.post(url, {}, { headers });
}

// 分享成功上报
export const reportShare = () => {
  let url = baseURL + 'h5/tokyoOlympic/share';
  const headers = getHeaders();
  return axios.post(url, {}, { headers });
}

// 推荐游戏列表
export const queryRecommendGame = () => {
  let url = baseURL + 'h5/tokyoOlympic/query/hotGames';
  const headers = getHeaders();
  return axios.post(url, {}, { headers });
}

// 查询东奥勋章接口
export const queryMedal = () => {
  let url = baseURL + 'h5/tokyoOlympic/query/olympicMedal';
  const headers = getHeaders();
  return axios.post(url, {}, { headers });
}

// 任务查询接口
export const queryTaskInfo = () => {
  let url = baseURL + 'h5/tokyoOlympic/query/userTaskInfo';
  const headers = getHeaders();
  return axios.post(url, {}, { headers });
}

// 奖励领取接口
export const rewardCollection = (param) => {
  let url = baseURL + 'h5/tokyoOlympic/rewardCollection';
  const headers = getHeaders();
  return axios.post(url, param, { headers });
}






// WEBPACK FOOTER //
// ./src/api/tokyoOlympicApi.js